import $ from 'jquery';
import Handlebars from 'handlebars';
import langFromUrl from 'lib/util/langFromUrl';
import PageCache from 'lib/page-cache';
import tdaConfig from 'lib/util/tda.config';
import disclaimersService from 'components/disclaimers';
import inventoryXform from 'lib/transforms/inventory';
import getParameterByName from 'lib/getParameterByName';
import readableMonetize from 'lib/readable-monetize';
import inventoryService from 'lib/services/inventory-service';
import txtFilters from './inventory.results.filters.hbs';
import txtCards from './inventory.results.cards.hbs';
import queryStringObj from 'lib/queryStringObj';
import offersAnimations from 'lib/animations/offers.animations';
import filtersAnimations from 'lib/animations/filters.animations';
import gsap from 'lib/shim/gsap';
import blocks from 'lib/analytics/blocks/index';
import anComponentView from 'lib/analytics/componentView';
import anClicks from 'lib/analytics/click';
import anClickManual from 'lib/analytics/click.manual';
import anAddContext from 'lib/analytics/context.add';
import 'bootstrapCollapse';
import 'lib/helpers/if_eq';
import 'lib/helpers/disclaimer';
import 'lib/helpers/concat';
import 'lib/helpers/cleanify';
import 'lib/helpers/toJSON';
import 'jqueryui';
import 'jquerytouch';
import 'components/isotope';
import 'lib/transforms/allseries.mapByCode';

var __initialized = false;
var __tmplFilters = Handlebars.compile(txtFilters);
var __tmplCards = Handlebars.compile(txtCards);
var __invTitle; // stash inventory title via changeTitle here
var __url = window.location.search.substring(1);
var __ogMsrpMin; // stash for our OG MSRPS from OG vehicle filters request
var __ogMsrpMax; // stash for our OG MSRPS from OG vehicle filters request
var __avaliableYears;
var __filterIsPressed = false;

function __defaultYearForSeries(defaultYears, currentSeries) {
  var tmpObj = {};
  defaultYears.InventoryYear.Vehicle.forEach(function (item) {
    tmpObj[item.Series] = {
      year: Number(item.SeriesYear),
      nCount: item.InventoryResultsDisplay
    };
  });
  return tmpObj[currentSeries] || { year: (new Date()).getFullYear(), nCount: 'year-2' };
}

// create yearsAvailable array based on TDA configured default year - year-count
// (configurable via /templatedata/BAT/InventoryFilter/data)
function __yearsAvailable(seriesYearOptions) {
  var count = seriesYearOptions.nCount.split('-')[1]; // returns 1 or 2
  var tmpArr = [];
  tmpArr.push(seriesYearOptions.year.toString());
  if (count) {
    var initYear = seriesYearOptions.year;
    while (count > 0) {
      initYear = initYear - 1;
      tmpArr.push(initYear.toString());
      count--;
    }
  }
  return tmpArr;
}

function __filterObject(name, type, objects) {
  var filterObject = {};
  filterObject.name = name;
  filterObject.list = [];

  $.each(objects, function (indx, codeObj) {
    var fctCount = objects[indx].count;
    var hexValHolder;
    if (fctCount > 0) {
      // Two-toned vehicle colors contain a hexValueArray property. Handle them here
      if (typeof codeObj.hexValueArray === 'string') {
        hexValHolder = [];
      } else {
        hexValHolder = codeObj.hexValueArray;
      }
      /*----------------------------------------------------------------------------------------
      Strip disclaimers on ALL filters
      ----------------------------------------------------------------------------------------*/
      var txt = codeObj.title;
      txt = txt.replace(/\[.*?\]/g, '');

      // Adjust color filter
      if (type.indexOf('color') > -1) {
        filterObject.list.push({
          // filter: codeObj.title,
          filter: txt, // just use text instead of replacing again, later on down the line. do this for all?
          imageURL: codeObj.hexValue,
          imageURLVirt: hexValHolder,
          name: txt,
          paramKey: type,
          total: codeObj.count,
          paramValue: codeObj.code
        });

      // Adjust 'packages' filter (these come in as accessories)
      // only use accessories that have a property of derived: 'false', in our packages filter
      } else if (type.indexOf('accessory') > -1) {
        if (codeObj.derived === 'false') {
          var tmpObj = {
            filter: codeObj.title,
            name: txt,
            paramKey: type,
            total: codeObj.count,
            paramValue: codeObj.code,
            type: codeObj.type
          };
          if (codeObj.type === 'FIO') {
            tmpObj.paramKey = 'packages';
          }

          filterObject.list.push(tmpObj);
        }
      } else {
        filterObject.list.push({
          filter: codeObj.title,
          name: txt,
          paramKey: type,
          total: codeObj.count,
          paramValue: codeObj.code
        });
      }
    }
  });

  if ( objects.length > 0 ) {
    if (filterObject.name === 'packages') {
      filterObject.pickone = false;
    } else {
      filterObject.pickone = true;
    }
  }

  return filterObject;
}

// filters FROM the inv service. These are the available filters based on initial query
function __availableFilters(filterObj) {
  var typeToIT = [
    'color-exteriorcolor',
    'models-grade',
    'cab-cab',
    'engine-engine',
    'transmission-transmission',
    'drive-drive',
    'packages-accessory'
  ];
  var filtersArr = [];
  var typeObj = {};

  for (var i = 0; i < typeToIT.length; i += 1) {
    var nameSplit = typeToIT[i].split('-')[0];
    var typeSplit = typeToIT[i].split('-')[1];
    typeObj[typeSplit] = nameSplit;
  }

  for (var key in typeObj) {
    var filterResp = {};
    if (filterObj[key] !== undefined) {
      filterResp = __filterObject(typeObj[key], key, filterObj[key]);
      filtersArr.push(filterResp);
    }
  }
  return filtersArr;
}

function __validateServiceParams(newObj) {
  var sort = newObj.sortorder ? newObj.sortorder[0] : 'ASC';
  /*
  sample of OBJ we're returning:
  var sampleObj = {
    sortorder: 'ASC',
    filter: {
      accessory: ['2T', 'WL'],
      engine: ['35lv6'],
      exteriorcolor: ['01H2'],
      grade: ['XLE'],
      msrp: [34409, 42838],
      packages: ['FE'],
      transmission: ['6AT'],
      year: ['2018']
    }
  };
  */
  var reqObj = {
    sortorder: sort,
    filter: {
      accessory: newObj.accessory || [],
      engine: newObj.engine || [],
      exteriorcolor: newObj.exteriorcolor || [],
      grade: newObj.grade || [],
      packages: newObj.packages || [],
      transmission: newObj.transmission || [],
      year: newObj.year || []
    }
  };
  // service calls fail w/empty arr for msrp. Only add if we have one
  if (newObj['msrp[0]'] && newObj['msrp[1]']) {
    reqObj.filter.msrp = [newObj['msrp[0]'][0], newObj['msrp[1]'][0]];
  }
  return reqObj;
}

function __serviceFiltersFromQs(queryString) {
  if (queryString === '') return {};
  var queryStringAsObj = queryStringObj(decodeURIComponent(queryString));
  var newObj = {};
  $.each(queryStringAsObj, function (prop, value) {
    newObj[prop] = value.split(',');
  });
  return __validateServiceParams(newObj);
}

function __updateAndReplaceState(paramObj) {
  var urlObj = queryStringObj(decodeURIComponent(__url));
  $.each(paramObj, function (prop, val) {
    urlObj[prop] = val;
  });
  __url = $.param(urlObj);
  window.history.replaceState({}, '', window.location.pathname + '?' + __url);
}

function __setStats(statsObj) {
  if (statsObj.msrp) {
    __ogMsrpMin = statsObj.msrp.min;
    __ogMsrpMax = statsObj.msrp.max;
  } else {
    __ogMsrpMin = 0;
    __ogMsrpMax = 0;
  }
}

var InventoryVehicle = function (el, config) {
  var series = getParameterByName('series');
  var seriesYearOptions = __defaultYearForSeries(config.defaultYears, series);
  this.$el = $(el);
  this._config = $.extend({}, InventoryVehicle.defaultConfig, { defaultYear: seriesYearOptions.year }, config);
  this._series = series;
  this._yearsAvailable = __yearsAvailable(seriesYearOptions);
  __avaliableYears = __yearsAvailable(seriesYearOptions);
  var index = __avaliableYears.indexOf(__avaliableYears[0])
  __avaliableYears.splice(index,1)
  this.initialize.apply(this, arguments);
};

InventoryVehicle.defaultConfig = {
  defaultYear: 2018,
  defaultSort: 'ASC',
  $isotopeContainer: '#isotope-inventory',
  // BAT25-506 $yearSelect: '#year-select-inventory',
  $invFilters: '#inventory-filters',
  $showMoreBtn: '#show-more-button',
  // BAT25-506 $sortSelect: '#sort-by-select-inventory',
  $filtersOpen: '#open-filters-button',
  $filtersClose: '#close-filters-button',
  $filtersPanel: '#filters-panel',
  $doneButton: '#done-button',
  $sliderRange: '#slider-range'
};

InventoryVehicle.Disclaimers = {
  cachedDisclaimerMap: {},
  createDisclaimersMap: function (disclaimersObj) {
    disclaimersService.vehicleDisclaimers = [];
    var staticOffset = (document.getElementById('disclaimers-global-modal').outerHTML.match(/static-disclaimer/g) || []).length;
    var count = 0;
    var disclaimerMap = {}; // used to lookup replaces
    Object.keys(disclaimersObj).forEach(function (key) {
      var obj = {
        symbol: count + staticOffset + 1,
        description: disclaimersObj[key].description
      };
      count += 1;
      disclaimerMap['[' + key + ']'] = obj.symbol;
      disclaimersService.vehicleDisclaimers.push(obj);
    });
    InventoryVehicle.Disclaimers.cachedDisclaimerMap = disclaimerMap;
  },

  replaceDisclaimerTags: function (html) {
    var cleanHtml = html;
    var results = html.match(/\[.*?\]/g);
    if (results) {
      $.each(results, function (i, val) {
        var replaceWith = '';
        if (InventoryVehicle.Disclaimers.cachedDisclaimerMap[val] !== undefined) {
          // Only do the following,
          // If this disclaimer falls inside of a <div class="card-inner">, within our html
          replaceWith = '<sup class="color-red footnote"><a href="#" class="js-disclaimer-inv">' + InventoryVehicle.Disclaimers.cachedDisclaimerMap[val] + '</a></sup>';
        }
        cleanHtml = cleanHtml.replace(val, replaceWith);
      });
    }
    // return html
    return cleanHtml;
  }
};

// .load invoked via inventory-vehicle.xsl
$.extend(InventoryVehicle.prototype, {
  initialize: function (el, config) {
    console.log('InventoryVehicle initialize: ', this);
  },

  load: function () {
    var self = this;
    var locali18n = {
      en: {
        clear: 'CLEAR', allSelected: 'All Selected', allColorsSelected: 'All Colors Selected', selected: 'Selected', show: 'Show', vehicles: 'Vehicles', min: 'Min', max: 'Max',
        priceSet: 'Price Range Set', priceRange: 'Price Range',
        year: 'Year', sortorder: 'Sort by', lowest: 'Price: Low to High', highest: 'Price: High to Low',
        color: 'Color', colors: 'Colors', models: 'Model', engine: 'Engine', transmission: 'Transmission', drive: 'Drive', packages: 'Packages',
        to: 'TO'
      },
      es: {
        clear: 'BORRAR', allSelected: 'Elegiste todo', allColorsSelected: 'Elegiste todo colores', selected: 'Elegiste', show: 'Ver', vehicles: 'veh&#x00ED;culo(s)', min: 'Mín', max: 'Máx',
        priceSet: 'Precio fijado', priceRange: 'Rango de precios',
        year: 'Año', sortorder: 'Ordenar por', lowest: 'Precio m&#x00E1;s bajo', highest: 'Precio m&#x00E1;s alto',
        color: 'Color', colors: 'Colores', models: 'Modelos', engine: 'Motor', transmission: 'Tramsmisión', drive: 'Conducción', packages: 'Paquetes',
        to: 'A'
      }
    };
    self.lang = langFromUrl();
    self.locali18n = locali18n[self.lang] || locali18n.en;
    if (self._config && self._config.i18n) {
      $.extend(self._config.i18n, self.locali18n);
      $.extend(self.locali18n, self._config.i18n);
    }

    self.addSelectors();
    self.$isotopeContainer.isotope({ itemSelector: '.card' });
    self.addConfigsFromUrl();
    var serviceParams = __serviceFiltersFromQs(__url);
    // BAT25-506 self.buildYearSelect();
    // BAT25-506 self.buildSortSelect();
    // hide old filters if still there
    $('#sort-by-select-inventory').closest('div.row').hide();
    $('#year-select-inventory').closest('div.row').hide();
    self.$stickyFilters = $('#filters-panel .sticky-head');
    if (self.$stickyFilters.length > 0) {
      var clearBtn$ = $(self.$stickyFilters).find('a').length > 0 ? $(self.$stickyFilters).find('a')[0] : null;
      if (!clearBtn$) {
        clearBtn$ = $("<a class='clear-filters-button datalayer-link'>" + self.locali18n.clear + '</a>');
        $(self.$stickyFilters).prepend(clearBtn$);
      }
    }

    // 1) request all available filters just for this series & default year
    self.requestAvailFilters();

    // 2) request inventory based on filters from queryString
    self.requestInventory('inventory.results.init', serviceParams);

    /* 3) request inventory just for stats (min/max MSRP)
    Only do this if we MUST (when GRADE or MSRP is present in url)
    this is because we want min/max MSRPS for the series, NOT series + grade
    note that subsequent filter edits will not do this again. */
    if (serviceParams.filter.grade.length || serviceParams.filter.msrp) {
      self.requestInventory('inventory.stats');
    } else {
      PageCache.await('inventory.results.init')
        .then(function (res) {
          PageCache.set('inventory.stats', res);
        });
    }

    // new set of filters listener (new filters are requested on load and on year change only)
    PageCache.on('inventory.filters', function (cache) {
      // BAT25-506 add year/orderby filter, add multiselect, add translations
      var multiselect = ['color', 'models', 'engine', 'transmission', 'packages'];
      var filtersForVehicle = __availableFilters(cache.body.response.docs[0]) || [];
      if (filtersForVehicle && filtersForVehicle.length > 0) {
        for (var i = 0; i < filtersForVehicle.length; i += 1) {
          var fltr = filtersForVehicle[i];
          if (fltr.name && multiselect.indexOf(fltr.name) >= 0) fltr.pickone = false;
          fltr.i18n = { name: self.stripLastChar(self.locali18n[fltr.name] ? self.locali18n[fltr.name] : fltr.name, ':') };
        }
      }
      var yearFilter = {
        list: [], name: 'year', pickone: false, i18n: { name: self.locali18n.year }
      };
      self._yearsAvailable.forEach(function (item, idx, ogArr) {
        yearFilter.list.push({
          filter: item,
          name: item,
          paramKey: 'year',
          paramValue: item
        });
      });
      filtersForVehicle.unshift(yearFilter);
      var sortFilter = {
        list: [
          {
            filter: 'sortorder', name: 'ASC', paramKey: 'sortorder', paramValue: 'ASC', i18n: { name: self.locali18n.lowest }
          },
          {
            filter: 'sortorder', name: 'DESC', paramKey: 'sortorder', paramValue: 'DESC', i18n: { name: self.locali18n.highest }
          },
        ],
        name: 'sortorder', pickone: true, i18n: { name: self.locali18n.sortorder }
      };
      // filtersForVehicle.unshift(sortFilter);
      self.displayFilters([sortFilter], true);
      self.displayFilters(filtersForVehicle, false);
      $('#filter-price-range-additional-label').html(self.locali18n.priceRange);
      $('#slider-middle-text').html(self.locali18n.to);
      self.preSelectFilters();
      self.filterClicks();
    });

    // main listener
    PageCache.on('inventory.results', function (cache) {
      self.uiObject = self.handleResponse(cache);
      self.showResults();
      if(!__filterIsPressed && typeof __filterIsPressed !== "undefined"){
          self.addConfigsFromUrl();
          __setStats(self.uiObject.stats);
          self._config.priceUser = self.addPriceUser();
          self.priceFilterBuild(__ogMsrpMin, __ogMsrpMax); // only need to do this ONCE with ogPrices!
          self.priceFilterUserPref(self._config.priceUser[0], self._config.priceUser[1]);
          self.removeFilters();
          self.requestAvailFilters();
      }
    });

    // listener for inventory results after year change
    PageCache.on('inventory.results.newYear', function (cache) {
      self.addConfigsFromUrl();
      self.uiObject = self.handleResponse(cache);
      __setStats(self.uiObject.stats);
      self._config.priceUser = self.addPriceUser();
      self.priceFilterBuild(__ogMsrpMin, __ogMsrpMax); // only need to do this ONCE with ogPrices!
      self.priceFilterUserPref(self._config.priceUser[0], self._config.priceUser[1]);
      self.showResults();
    });

    // only happens on load
    PageCache.awaitAll(['inventory.results.init', 'inventory.stats'])
      .then(function (res) {
        var stats = res[1].body.response.stats; // contains min/max MSRP data
        res[0].body.response.stats = stats;
        __setStats(stats);
        if (self._config.priceUser.length === 0) {
          self._config.priceUser = self.addPriceUser();
        }
        self.priceFilterBuild(__ogMsrpMin, __ogMsrpMax);
        self.priceFilterUserPref(self._config.priceUser[0], self._config.priceUser[1]);
        PageCache.set('inventory.results', res[0]);
      });
  },

  stripLastChar: function (strval, chr) {
    var retv = strval;
    if (strval && typeof strval == 'string') {
      if (chr && strval.slice(-1) == chr || !chr)
        retv = strval.slice(0, -1);
    }
    return retv;
  },

  // BAT25-506
  addFilterCounts: function () {
    var self = this;
    var allSelectedFiltersCnt = 0;
    function getFilterCountSpan(btn$) {
      var span$ = $(btn$).find('.filter-count').length > 0 ? $(btn$).find('.filter-count')[0] : null;
      if (!span$) {
        span$ = $("<span class='filter-count'></span>");
        $(btn$).find('i').before(span$);
      }
      return span$;
    }
    $('#filters-panel .filters').children('li').not('.ul-wrapper').each(function (idx, el) {
      var filterId = $(el).attr('id');
      if (!filterId) filterId = $('ul', $(el)).attr('id');
      var btn$ = $(el).find('button').length > 0 ? $(el).find('button')[0] : null;
      if (btn$) {
        var span$ = getFilterCountSpan(btn$);
        if ($(btn$).data('linktext') === 'sortorder') {
          $(span$).html($("label[for='" + $(':checked', $(el)).attr('id') + "'] .inventory-filter-name").text());
        } else if (filterId === 'filter-price') {
          var slidervals = $(self.$sliderRange).slider('values');
          if (slidervals && slidervals.length > 0 && (slidervals[0] != __ogMsrpMin
            || (slidervals.length > 1 && slidervals[1] != __ogMsrpMax))) {
            $(span$).html(self.locali18n.priceSet);
            allSelectedFiltersCnt += 1;
          } else $(span$).html('');
        } else {
          var totalCnt = $(el).find(':checkbox').length;
          var checkedCnt = $(el).find(':checked').length;
          if (totalCnt > 0) {
            var showCnt = '';
            if (totalCnt === checkedCnt) showCnt = (filterId === 'filter-color' ? self.locali18n.allColorsSelected : self.locali18n.allSelected);
            else if (checkedCnt > 0) {
              if (filterId === 'filter-color') {
                if (self.lang === 'es') {
                  showCnt = self.locali18n.selected + ' (' + checkedCnt + ') ' + (checkedCnt === 1 ? self.locali18n.color : self.locali18n.colors);
                } else {
                  showCnt = '(' + checkedCnt + ') ' + (checkedCnt === 1 ? self.locali18n.color : self.locali18n.colors) + ' ' + self.locali18n.selected;
                }
              } else {
                showCnt = self.lang === 'es' ? (self.locali18n.selected + ' (' + checkedCnt + ')') : ('(' + checkedCnt + ') ' + self.locali18n.selected);
              }
            }
            $(span$).html(showCnt);
          }
          allSelectedFiltersCnt += checkedCnt;
        }
      }
    });
    var headSpan$ = $('#filters-panel .sticky-head span');
    if (headSpan$.length > 0) {
      var hdNumSpan$ = $(headSpan$).find('.filter-count-head').length > 0 ? $(headSpan$).find('.filter-count-head')[0] : null;
      if (!hdNumSpan$) {
        hdNumSpan$ = $("<span class='filter-count-head'></span>");
        $(headSpan$).append(hdNumSpan$);
      }
      var txt = '';
      if (allSelectedFiltersCnt > 0) txt = '(' + allSelectedFiltersCnt + ')';
      $(hdNumSpan$).text(txt);
    }
    var btnDone$ = $('#done-button');
    if (btnDone$ && !(btnDone$.find('span').length > 0)) {
      var total = $('.total-found').html() || '';
      $(btnDone$).html(self.locali18n.show + " <span class='total-found'>" + total + '</span> ' + self.locali18n.vehicles);
    }
  },

  // add configurable selectors to this instance
  addSelectors: function () {
    this.$isotopeContainer = this.$el.find(this._config.$isotopeContainer);
    // BAT25-506 this.$yearSelect = this.$el.find(this._config.$yearSelect);
    this.$invFilters = this.$el.find(this._config.$invFilters);
    this.$showMoreBtn = this.$el.find(this._config.$showMoreBtn);
    // BAT25-506 this.$sortSelect = this.$el.find(this._config.$sortSelect);
    this.$filtersOpen = this.$el.find(this._config.$filtersOpen);
    this.$filtersClose = this.$el.find(this._config.$filtersClose);
    this.$filtersPanel = this.$el.find(this._config.$filtersPanel);
    this.$doneButton = this.$el.find(this._config.$doneButton);
    this.$sliderRange = this.$el.find(this._config.$sliderRange);
  },

  addConfigsFromUrl: function () {
    var self = this;
    var qsYear = getParameterByName('year');
    var qsSort = getParameterByName('sortorder');
    var qsMsrpMin = getParameterByName('msrp[0]');
    var qsMsrpMax = getParameterByName('msrp[1]');

    // modify default year of this instance
    // do we have a year in the querystring AND that year is available in our TDA configured _yearsAvailable?
    if (qsYear && (self._yearsAvailable.indexOf(qsYear) >= 0)) {
      self._config.defaultYear = qsYear; // its available. Just use it.
    } else {
      __updateAndReplaceState({ year: self._config.defaultYear });
    }

    // modify this instances default sort
    if (qsSort) {
      qsSort = (qsSort + '').toLowerCase();
      if (qsSort === 'asc' || qsSort === 'desc') {
        self._config.defaultSort = qsSort === 'asc' ? 'ASC' : 'DESC';
      }
    } else {
      __updateAndReplaceState({ sortorder: self._config.defaultSort });
    }

    // add a user selected MSRP to this instance.
    // (NOT min/max on slider), this qs value is used to pre-select the min/max slider
    // if we DO NOT have one, we can't add one here, we need to do that after the service responds with min/max msrp and use those
    if (qsMsrpMin && qsMsrpMax) {
      self._config.priceUser = self.addPriceUser(qsMsrpMin, qsMsrpMax);
    } else {
      self._config.priceUser = [];
    }
  },

  // add _config.priceUser with min/max MSRP from either the URL OR from __og saved at inv response
  // update the URL. msrp[0]=34409&msrp[1]=42809
  addPriceUser: function (qsMsrpMin, qsMsrpMax) {
    qsMsrpMin = qsMsrpMin || __ogMsrpMin;
    qsMsrpMax = qsMsrpMax || __ogMsrpMax;
    __updateAndReplaceState({ 'msrp[0]': qsMsrpMin, 'msrp[1]': qsMsrpMax });
    return [Number(decodeURIComponent(qsMsrpMin)), Number(decodeURIComponent(qsMsrpMax))];
  },

  showResults: function () {
    var self = this;
    this.checkZero();
    this.paintCounts(this.uiObject);
    self.addFilterCounts();
    this.appendCards(this.uiObject);
    this.checkShowMore();
    // TODO: Better way to do this. Have to wait until dom is fully ready otherwise disclaimer service breaks.
    $(function () {
      disclaimersService.msrpMpgDigits(self._config.$isotopeContainer);
    });
    if (!__initialized) {
      this.changeTitle();
      this.cardContentDisclaimerClicks();
      this.clearClick();
      this.sortChange();
      this.yearChange();
      this.mobileFilterClicks();
      this.popState();
      this.addFab();
      anClicks(this.$el);
    }
    offersAnimations.animateOfferCards();
    this.doDataLayer();
    __initialized = true;
  },

  doDataLayer: function () {
    var currIsotopeLayout = function () {
      if ($('#list-button').hasClass('active')) {
        return 'list';
      }
      return 'grid';
    };
    anAddContext(
      this.$el,
      blocks.seriesBlock({
        series_code: this._series,
        year: getParameterByName('year'),
        grade: getParameterByName('grade'),
        engine: getParameterByName('engine'),
        transmission: getParameterByName('transmission'),
        packages: getParameterByName('accessory'),
        color_ext: getParameterByName('exteriorcolor') && this.uiObject.items.length ? this.uiObject.items[0].dataLayer.series_color_ext : '',
        color_ext_code: getParameterByName('exteriorcolor'),
        accessories_name: getParameterByName('accessory'),
      }),
      blocks.inventoryListBlock({
        count: this.uiObject.numFound.toString(),
        layout: currIsotopeLayout(),
        filter: this.filtersToQueryString(),
        selector: this.filtersToQueryString(),
      })
    );
    if (__initialized) {
      anComponentView(this.$el);
    } else {
      anComponentView(this.$el, blocks.keyMetrics('km-inventory-result'));
    }
  },

  checkZero: function () {
    var self = this;
    if (self.uiObject.numFound === 0) {
      if(__avaliableYears.length > 0 && !__filterIsPressed){
        self.removeResults();
        var filterParam = self.getFilters();
        var searchForYear = __avaliableYears[0];
        self._config.defaultYear = searchForYear;
        //BAT-6118 We had to set initial value of msrp, to be able to do first search at all, because initial value of msrp is 0 if no vehicles are found
        filterParam.filter.msrp[0] = "1";
        filterParam.filter.msrp[1] = "600000";
        filterParam.filter.year.push(searchForYear);
        //this.removeFilters();
        setTimeout(function() {
          self.requestInventory('inventory.results', filterParam);
        }, 0);
          var index = __avaliableYears.indexOf(__avaliableYears[0]);
          __avaliableYears.splice(index,1);
          __filterIsPressed = false;
        setTimeout(function(){
          $(':checked', this.$invFilters).each(function () {
            if ($(self).data('param-key') !== 'sortorder') $(self).prop('checked', false);
          });
          $('li [data-param-value="' + searchForYear + '"]', $('ul[id="filter-year"]', self.$invFilters)).prop('checked', true);


        }, 2000);
      }else {
        gsap.TweenLite.to(window, 0.5, { scrollTo: 200 });
        self.itemsZero();

      }

    } else {

      self.itemsNotZero();
    }
  },

  itemsZero: function () {
    $('#no-vehicles-found-initial').show();
    $('#showing-number-of-total').hide();
    $('#show-more-button').hide();
    $('.total-found').html('0');
  },

  itemsNotZero: function () {
    $('#no-vehicles-found-initial').hide();
    $('#showing-number-of-total').show();
    this.$invFilters.show();
    $('#show-more-button').show();
  },

  requestAvailFilters: function () {
    this.requestInventory('inventory.filters', {
      facetfields: ['exteriorcolor', 'grade', 'cab', 'bed', 'drive', 'engine', 'transmission', 'accessory']
    });
  },

  requestInventory: function (cacheId, options) {
    var self = this;
    var defaultOptions = {
      filter: {},
      fields: [],
      pagesize: 9,
      pagestart: 0,
      facetfields: [],
      sortfield: 'MSRP',
      sortorder: self._config.defaultSort,
      group: 'true',
      groupmode: 'full',
      mode: 'content'
    };
    var defaultFilter = {
      region: [tdaConfig.inventory.region_code], // shouldnt we actually just default to 600?
      series: [self._series],
      year: [self._config.defaultYear],
      dealers: []
    };

    var invRequest = $.extend({}, defaultOptions, options);
    invRequest.filter = $.extend({}, defaultFilter, invRequest.filter);

    if (!PageCache.isPending(cacheId)) {
      PageCache.maybeSet(cacheId, inventoryService.inventory().getInventory(invRequest));
    }
  },

  handleResponse: function (resolvedData) {
    var start = this.uiObject ? this.uiObject.displayingRecordsCount : 0;
    var total = resolvedData.body.response.numFound;
    var stats = resolvedData.body.response.stats;
    // TODO: determine a better way to do this
    $(function () {
      // Have to wait until dom is fully ready otherwise disclaimer service breaks.
      InventoryVehicle.Disclaimers.createDisclaimersMap(resolvedData.body.response.disclaimers);
    });

    var xformedCards = inventoryXform({ data: resolvedData });
    var uiObject = {
      i18n: this._config.i18n,
      siteContext: tdaConfig.site.context_url,
      items: xformedCards,
      stats: stats,
      numFound: total,
      displayingRecordsCount: start + xformedCards.length
    };
    this.uiObject = uiObject;
    return uiObject;
  },

  checkShowMore: function () {
    var self = this;
    if (self.uiObject.displayingRecordsCount >= self.uiObject.numFound) {
      self.$showMoreBtn.hide();
    } else {
      self.$showMoreBtn.show();
      self.$showMoreBtn.off('click');
      self.$showMoreBtn.on('click', function () {
        var filterParam = self.getFilters();
        filterParam.pagestart = self.uiObject.displayingRecordsCount;
        self.requestInventory('inventory.results', filterParam);
      });
    }
  },

  // Empty and rebuild the year-select dropdown, based on the configurable N-X years in the DCR
  // (provided via config in inventory-vehicle.xsl)
  buildYearSelect: function () {
    var self = this;
    $(self.$yearSelect).empty();
    self._yearsAvailable.forEach(function (item, idx, ogArr) {
      $(self.$yearSelect).append($('<option>', {
        value: item,
        text: item
      }));
    });
    $(self.$yearSelect).val(self._config.defaultYear).dropkick({mobile: false});
  },

  buildSortSelect: function () {
    var self = this;
    var val = self._config.defaultSort.toLowerCase() === 'asc' ? 'lowest' : 'highest';
    $(self.$sortSelect).val(val).dropkick({ mobile: false });
  },

  displayFilters: function (filtersObj, prepend = true) {
    var handlebarsHTML = __tmplFilters({ filters: filtersObj });
    var $newItems = $(handlebarsHTML);
    if (prepend) $(this.$invFilters).prepend($newItems);
    else $(this.$invFilters).append($newItems);
    $('[data-target="#filter-models"]').addClass('open'); // for mobile
    $('#filter-models').addClass('in'); // for desktop
  },

  // remove filters from DOM (except for price filter)
  removeFilters: function () {
    this.uncheckFilters();
    $(this.$invFilters).children('li').not('li#filter-price').remove();
  },

  // uncheck all filters and do default search
  resetFilters: function () {
    var self = this;
    self.uncheckFilters();
    // BAT25-506 check default year
    $('li [data-param-value="' + self._config.defaultYear + '"]', $('ul[id="filter-year"]', self.$invFilters)).prop('checked', true);
    self.removeResults();
    self.requestInventory('inventory.results', {sortorder: this.getSort()});
  },

  uncheckFilters: function () {
    $(':checked', this.$invFilters).each(function () {
      if ($(this).data('param-key') !== 'sortorder') $(this).prop('checked', false);
    });
  },

  paintCounts: function (uiObject) {
    var numFound = uiObject.numFound;
    var displayingRecordsCount = uiObject.displayingRecordsCount;
    if (numFound <= displayingRecordsCount) {
      displayingRecordsCount = numFound;
    }
    $('.total-found').html(readableMonetize(numFound));
    $('#showing-number-of-total .number').html(displayingRecordsCount);
  },

  appendCards: function (uiObject) {
    var self = this;
    // tack on another data-layer item
    uiObject.items.forEach(function (item, idx) {
      $.extend(item.dataLayer, blocks.listItemBlock(idx));
    });

    console.log('CTX for inv cards: ', uiObject);
    var handlebarsHTML = __tmplCards(uiObject);
    handlebarsHTML = InventoryVehicle.Disclaimers.replaceDisclaimerTags(handlebarsHTML);
    var $newItems = $(handlebarsHTML);

    self.$isotopeContainer.isotope('insert', $newItems);
    // TODO: determine a better way to do this
    $(function () {
      // Have to wait until dom is fully ready otherwise disclaimer service breaks.
      disclaimersService.appendDisclaimers();
    });

    $('.card .year-and-model.textfit-one-line').textFit({
      alignHoriz: true, alignVert: true, minFontSize: 8, maxFontSize: 17, multiLine: false
    });
    $('.card .inventory-trim.textfit-one-line').textFit({
      alignHoriz: true, alignVert: true, minFontSize: 8, maxFontSize: 14, multiLine: false
    });

    // BAT-2522: manage series names that are exceedlingly long.
    var yams = $('.year-and-model.textfit-one-line');
    yams.each(function (index, item) {
      if ($(item).find('.font-bold').html().length >= 40) {
        $(item).css('font-size', '14px');
      }
    });
  },

  changeTitle: function () {
    var self = this;
    if (!__invTitle) {
      PageCache.await('allseries.map')
        .then(function (seriesMap) {
          var series = seriesMap[self._series].series_display_name;
          __invTitle = (self.lang === 'es') ? 'Inventario ' + series : series + ' Inventory';
          $('#inpage-headline').html(__invTitle);
          $('.change-vehicle-offset').insertAfter('#inpage-headline');
        })
        .catch(function (err) { console.log('err: ', err); });
    }
  },

  priceFilterBuild: function (minPrice, maxPrice) {
    var self = this;
    var $sliderRange = $(self.$sliderRange);
    minPrice = Number(minPrice);
    maxPrice = Number(maxPrice);
    if ($sliderRange.hasClass('ui-slider')) {
      $sliderRange.slider('destroy');
    }
    $sliderRange.slider({
      range: true,
      min: __ogMsrpMin,
      max: __ogMsrpMax,
      step: (__ogMsrpMax - __ogMsrpMin) / 100,
      values: [minPrice, maxPrice],
      slide: function (event, ui) {
        $('#slider-min-num').html('<sup class="dollar">$</sup>' + readableMonetize(ui.values[0], { maximumFractionDigits: 0 }));
        $('#slider-max-num').html('<sup class="dollar">$</sup>' + readableMonetize(ui.values[1], { maximumFractionDigits: 0 }));
        if (ui.handle.id === 'price-handle-0') {
          $('#price-handle-0').attr('aria-valuenow', readableMonetize(ui.values[0], { maximumFractionDigits: 0 }));
        } else {
          $('#price-handle-1').attr('aria-valuenow', readableMonetize(ui.values[1], { maximumFractionDigits: 0 }));
        }
      },
      stop: function (event, ui) {
        if (ui.values[0] == __ogMsrpMin) $('#slider-min-num').html(self.locali18n.min);
        else $('#slider-min-numslider-min-num').html('<sup class="dollar">$</sup>' + readableMonetize(ui.values[0], { maximumFractionDigits: 0 }));
        if (ui.values[1] == __ogMsrpMax) $('#slider-max-num').html(self.locali18n.max);
        else $('#slider-max-num').html('<sup class="dollar">$</sup>' + readableMonetize(ui.values[1], { maximumFractionDigits: 0 }));
        $('#price-handle-0').attr({
          'aria-valuemin': readableMonetize(ui.values[0], { maximumFractionDigits: 0 }),
          'aria-valuemax': readableMonetize(ui.values[1], { maximumFractionDigits: 0 })
        });
        $('#price-handle-1').attr({
          'aria-valuemin': readableMonetize(ui.values[0], { maximumFractionDigits: 0 }),
          'aria-valuemax': readableMonetize(ui.values[1], { maximumFractionDigits: 0 })
        });
        $('#slider-range').data('linktext', readableMonetize(ui.values[0], { maximumFractionDigits: 0 }) + '_-_' + readableMonetize(ui.values[1], { maximumFractionDigits: 0 }));
        var filterParam = self.getFilters();
        self.removeResults();
        self.requestInventory('inventory.results', filterParam);
        anClickManual(self.$el, $('#slider-range'));
        event.originalEvent.originalEvent.preventDefault();
      }
    });
    if (isNaN($sliderRange.slider('values', 0))) {
      $('#slider-min-num').hide();
    } else {
      $('#slider-min-num').show();
      var minnie = readableMonetize($sliderRange.slider('values', 0), { maximumFractionDigits: 0 });
      // $('#slider-min-num').html('<sup class="dollar">$</sup>' + minnie);
      $('#slider-min-num').html(self.locali18n.min);
      $('#price-handle-0').attr({
        'aria-valuenow': minnie,
        'aria-valuemin': minnie
      });
      $('#price-handle-1').attr('aria-valuemin', minnie);
    }
    if (isNaN($sliderRange.slider('values', 1))) {
      $('#slider-max-num').hide();
    } else {
      $('#slider-max-num').show();
      var maxie = readableMonetize($sliderRange.slider('values', 1), { maximumFractionDigits: 0 });
      // $('#slider-max-num').html('<sup class="dollar">$</sup>' + maxie);
      $('#slider-min-num').html(self.locali18n.max);
      $('#price-handle-0').attr({
        'aria-valuenow': maxie,
        'aria-valuemax': maxie
      });
      $('#price-handle-1').attr('aria-valuemax', maxie);
    }
  },
  priceFilterUserPref: function (userMin, userMax) {
    var self = this;
    var $sliderRange = $(this.$sliderRange);
    $sliderRange.slider('values', 0, userMin);
    $sliderRange.slider('values', 1, userMax);
    if (userMin == __ogMsrpMin) $('#slider-min-num').html(self.locali18n.min);
    else $('#slider-min-num').html('<sup class="dollar">$</sup>' + readableMonetize(userMin));
    if (userMax == __ogMsrpMax) $('#slider-max-num').html(self.locali18n.max);
    else $('#slider-max-num').html('<sup class="dollar">$</sup>' + readableMonetize(userMax));
    $('#price-handle-0').attr({
      'aria-valuemin': readableMonetize(userMin),
      'aria-valuemax': readableMonetize(userMax)
    });
    $('#price-handle-1').attr({
      'aria-valuemin': readableMonetize(userMin),
      'aria-valuemax': readableMonetize(userMax)
    });
  },

  removeResults: function () {
    this.$isotopeContainer.isotope('remove', this.$isotopeContainer.find('.isotope-item'));
    delete this.uiObject;
  },

  filterClicks: function () {
    var self = this;
    $('.filters .checkboxes li input').off('change');
    $('.filters .checkboxes li input').on('change', function (e) {
      e.stopPropagation();
      var $item = $(e.target);
      var $parentUL = $($item.closest('ul'));
      // BAT-2523 pickone items need to be cleared and have the most recent selection 'checked'.
      if ( $parentUL.hasClass('pickone') ) {
        // BAT-2523 CLEAR THE FILTERS ( only one item at a time can be selected for the pickone types)
        $(':checked', $parentUL).each(function () {
          $(this).prop('checked', false);
        });
        $item.prop('checked', true);
      }
      // BAT25-506 select default year if none selected
      if ($parentUL.attr('id') === 'filter-year' && $(':checked', $parentUL).length === 0) {
        $('li [data-param-value="' + self._config.defaultYear + '"]', $parentUL).prop('checked', true);
      }
      self.removeResults();
      // for testing:
      var filterParam = self.getFilters();
      self.requestInventory('inventory.results', filterParam);
      __filterIsPressed = true;
    });
  },

  sortChange: function () {
    var self = this;
    /* BAT25-506
    $(self.$sortSelect).on('change', function (e) {
      if (getParameterByName('sortorder') !== self.getSort()) {
        self.removeResults();
        self.requestInventory('inventory.results', self.getFilters());
      }
    });
    */
  },

  getSort: function () {
    var self = this;
    var sort = 'ASC';
    var $selChk = $('[data-param-key="sortorder"]:checked', self.$invFilters);
    if ($selChk.length > 0) sort = $selChk.data('param-value');
    return sort; // BAT25-506 $(this.$sortSelect).val() === 'lowest' ? 'ASC' : 'DESC';
  },

  yearChange: function () {
    var self = this;
    /* BAT25-506
    $(self.$yearSelect).on('change', function (e) {
      if (self._config.defaultYear !== e.target.value) {
        self._config.defaultYear = e.target.value;
        self.removeFilters();
        self.removeResults();
        self.requestAvailFilters(); // request new filters for this new search
        // ignore ALL filters for this new search (except for sort, which is not really a filter) on year change
        __url = 'series=' + self._series + '&year=' + self._config.defaultYear + '&sortorder=' + self.getSort();
        window.history.pushState({}, '', window.location.pathname + '?' + __url);
        self.requestInventory('inventory.results.newYear', { sortorder: self.getSort() });
      }
    });
    */
  },

  // updates URL & Returns a querystring, built from selected filters,
  // xform into filters OBJ for inv request
  getFilters: function () {
    var queryString = this.filtersToQueryString();
    var serviceParams = __serviceFiltersFromQs(queryString);
    window.history.pushState({}, '', location.pathname + '?series=' + this._series + '&' + queryString);
    return serviceParams;
  },

  // returns queryString from selected filters (and NON filters, like year and sortorder)
  // use selector here, and pass THAT to a XFORM?
  filtersToQueryString: function () {
    var tmpArr = [];
    $(':checked', this.$invFilters).each(function () {
      var $this = $(this);
      var tmpObj = {};
      tmpObj[$this.data('paramKey')] = $this.data('paramValue');
      tmpArr.push(tmpObj);
    });
    // year
    // BAT25-506
    // var yrObj = { year: $(this.$yearSelect).val() };
    // tmpArr.push(yrObj);
    // sortorder
    // BAT25-506
    // tmpArr.push({ sortorder: this.getSort() });

    // MSRPs only add as param if diff from OG
    var msrps = $(this.$sliderRange).slider('values');
    tmpArr.push({ 'msrp[0]': msrps[0] });
    tmpArr.push({ 'msrp[1]': msrps[1] });

    var reduced = tmpArr.reduce(function (acc, item) {
      var key = Object.keys(item)[0];
      // if this key exists, update it
      if (acc[key]) {
        acc[key] = acc[key] + ',' + item[key];
      } else {
        acc[key] = item[key];
      }
      return acc;
    }, {});
    return $.param(reduced); // return accumulated as querystring
  },

  // preselects "actual filters". NOT year, sort or price
  preSelectFilters: function () {
    var filters = queryStringObj(decodeURIComponent(__url));
    $('input', this.$invFilters).each(function () {
      var $this = $(this);
      var thisKey = $this.data('paramKey');
      var thisVal = $this.data('paramValue');
      var $parentUl = $this.closest('ul');
      // do pickone's
      if ( $parentUl.hasClass('pickone') ) {
        if ( filters.hasOwnProperty(thisKey) && (thisVal === filters[thisKey])) {
          $this.prop('checked', true);
          $parentUl.addClass('in');
        }
      // do multiple selects
      } else if ( filters.hasOwnProperty(thisKey) && (filters[thisKey].indexOf(thisVal) >= 0)) {
        $this.prop('checked', true);
        $parentUl.addClass('in');
      }
    });
  },

  // clear all filters and reset the price filter
  clearClick: function () {
    var self = this;
    $('.clear-filters-button').on('click', function () {
      __url = 'series=' + self._series + '&year=' + self._config.defaultYear + '&sortorder=' + self.getSort();
      self.addPriceUser();
      self.priceFilterUserPref(__ogMsrpMin, __ogMsrpMax);
      self.resetFilters();
    });
  },

  cardContentDisclaimerClicks: function () {
    $(this.$isotopeContainer).on('click', '.js-disclaimer-inv', function (e) {
      e.preventDefault();
      e.stopPropagation();
      disclaimersService.handleDisclaimers('vehicle', $(e.target).text());
    });
  },

  mobileFilterClicks: function () {
    this.$filtersClose.click(function () {
      filtersAnimations.close();
    });

    this.$doneButton.click(function () {
      filtersAnimations.close();
    });
  },

  popState: function () {
    window.onpopstate = function () {
      // trigger year change instead?
      window.location.reload();
    }
  },

  addFab: function () {
    import('bat-next')
      .then(function (BATNext) {
        BATNext.FABController.registerFab({
          id: 'fab-filter-inventory',
          weight: 50,
          icon: 'icon-filter',
          text: 'filter open',
          arialbl: 'Open Filter Menu',
          onClick: function () {
            filtersAnimations.open();
            // but why!!?
            setTimeout(function () {
              $('#sort-by-select-inventory').closest('div.row').hide();
              $('#year-select-inventory').closest('div.row').hide();
            }, 300);
          }
        });
        if (!BATNext.FABController.isMounted()) {
          BATNext.FABController.mountFabContainer(document.getElementById('fab-container'));
        }
      });
  }
});

export default InventoryVehicle;
